import { render, staticRenderFns } from "./order-card.html?vue&type=template&id=45fde9fe&scoped=true&class=most-top&"
import script from "./order-card.js?vue&type=script&lang=js&"
export * from "./order-card.js?vue&type=script&lang=js&"
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=45fde9fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fde9fe",
  null
  
)

export default component.exports